module.exports = __webpack_public_path__ + "img/Women Rights.5acde3ff.svg";